import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "overflow-hidden rounded-xl border border-[#E5E5E5] bg-[#FBFCFC]" }
const _hoisted_2 = { class: "flex items-center justify-between border-b border-[#E5E5E5] px-4 py-3" }
const _hoisted_3 = { class: "mt-0.5 text-sm font-semibold text-[#242B59]" }
const _hoisted_4 = { class: "rounded-full bg-[#48DDC3]/15 px-2.5 py-1 text-[10px] font-semibold text-[#168F7D]" }
const _hoisted_5 = { class: "overflow-x-auto" }
const _hoisted_6 = {
  key: 0,
  class: "min-w-[640px] text-left text-xs text-[#242B59]"
}
const _hoisted_7 = { class: "bg-white text-[#626468]" }
const _hoisted_8 = {
  key: 1,
  class: "min-w-[520px] text-left text-xs text-[#242B59]"
}
const _hoisted_9 = ["onMouseenter", "onFocus", "onClick", "onKeydown"]
const _hoisted_10 = {
  scope: "row",
  class: "max-w-[220px] truncate px-3 py-2 font-medium"
}
const _hoisted_11 = { class: "w-1/3 px-3 py-2" }
const _hoisted_12 = { class: "flex items-center gap-2" }
const _hoisted_13 = { class: "h-1.5 min-w-16 flex-1 overflow-hidden rounded-full bg-[#E5E5E5]" }
const _hoisted_14 = { class: "w-12 text-right text-[11px] font-medium text-[#626468]" }
const _hoisted_15 = {
  key: 0,
  class: "flex flex-col gap-2 border-t border-[#E5E5E5] px-3 py-2 text-xs text-[#626468] sm:flex-row sm:items-center sm:justify-between"
}
const _hoisted_16 = { class: "flex items-center gap-1" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "px-2" }
const _hoisted_19 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-[10px] font-semibold uppercase tracking-[0.16em] text-[#737373]" }, " Detalhamento ", -1 /* CACHED */)),
        _createElementVNode("p", _hoisted_3, _toDisplayString($setup.isStructuredTable ? $setup.structuredRows.length : $setup.rows.length) + " " + _toDisplayString($setup.isStructuredTable ? 'registros' : 'categorias'), 1 /* TEXT */)
      ]),
      _createElementVNode("span", _hoisted_4, _toDisplayString($setup.isStructuredTable ? 'Lista detalhada' : 'Passe o mouse para explorar'), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_5, [
      ($setup.isStructuredTable)
        ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
            _cache[4] || (_cache[4] = _createElementVNode("caption", { class: "sr-only" }, " Dados detalhados da consulta ", -1 /* CACHED */)),
            _createElementVNode("thead", _hoisted_7, [
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.columns, (column) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: column,
                    scope: "col",
                    class: "px-3 py-2 font-semibold"
                  }, _toDisplayString($setup.formatColumnLabel(column)), 1 /* TEXT */))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paginatedStructuredRows, (row, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: `${$setup.currentPage}-${index}`,
                  class: "border-t border-[#E5E5E5]"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.columns, (column) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: column,
                      class: "px-3 py-2 text-[#242B59]"
                    }, _toDisplayString($setup.formatAuraStructuredTableValue(column, row[column])), 1 /* TEXT */))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]))
        : (_openBlock(), _createElementBlock("table", _hoisted_8, [
            _cache[5] || (_cache[5] = _createElementVNode("caption", { class: "sr-only" }, " Dados detalhados do gráfico ", -1 /* CACHED */)),
            _cache[6] || (_cache[6] = _createElementVNode("thead", { class: "bg-white text-[#626468]" }, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "px-3 py-2 font-semibold"
                }, "Categoria"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "px-3 py-2 text-right font-semibold"
                }, "Valor"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "px-3 py-2 text-right font-semibold"
                }, "Participação")
              ])
            ], -1 /* CACHED */)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.rows, (row) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: row.label,
                  tabindex: "0",
                  class: _normalizeClass([
                            'group border-t border-[#E5E5E5] outline-none transition-all duration-200 hover:bg-[#48DDC3]/10 focus:bg-[#48DDC3]/10 focus:ring-2 focus:ring-inset focus:ring-[#48DDC3]',
                            $setup.activeLabel === row.label || $setup.props.selectedLabel === row.label
                                ? 'bg-[#48DDC3]/10'
                                : '',
                        ]),
                  onMouseenter: ($event: any) => ($setup.selectAndActivate(row)),
                  onFocus: ($event: any) => ($setup.selectAndActivate(row)),
                  onMouseleave: _cache[0] || (_cache[0] = ($event: any) => ($setup.activeLabel = null)),
                  onClick: ($event: any) => ($setup.selectRow(row)),
                  onKeydown: _withKeys(($event: any) => ($setup.selectRow(row)), ["enter"])
                }, [
                  _createElementVNode("th", _hoisted_10, [
                    _createElementVNode("span", {
                      class: "mr-2 inline-block h-2.5 w-2.5 rounded-full align-middle",
                      style: _normalizeStyle({ backgroundColor: row.color }),
                      "aria-hidden": "true"
                    }, null, 4 /* STYLE */),
                    _createTextVNode(" " + _toDisplayString($setup.formatAuraDateLabel(row.label)), 1 /* TEXT */)
                  ]),
                  _createElementVNode("td", {
                    class: "px-3 py-2 text-right font-semibold",
                    style: _normalizeStyle({ color: row.color })
                  }, _toDisplayString(row.value), 5 /* TEXT, STYLE */),
                  _createElementVNode("td", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", {
                          class: "h-full rounded-full transition-all duration-300",
                          style: _normalizeStyle({
                                            width: `${row.percentage ?? 0}%`,
                                            backgroundColor: row.color,
                                        })
                        }, null, 4 /* STYLE */)
                      ]),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(row.percentage === null
                                            ? '-'
                                            : `${row.percentage.toFixed(1)}%`), 1 /* TEXT */)
                    ])
                  ])
                ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_9))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]))
    ]),
    ($setup.isStructuredTable && $setup.structuredRows.length > $setup.rowsPerPage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("span", null, " Exibindo " + _toDisplayString(($setup.currentPage - 1) * $setup.rowsPerPage + 1) + " a " + _toDisplayString(Math.min($setup.currentPage * $setup.rowsPerPage, $setup.structuredRows.length)) + " de " + _toDisplayString($setup.structuredRows.length) + " registros ", 1 /* TEXT */),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("button", {
              type: "button",
              class: "rounded border border-[#E5E5E5] px-2 py-1 font-medium disabled:cursor-not-allowed disabled:opacity-40",
              disabled: $setup.currentPage === 1,
              "aria-label": "Página anterior",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.currentPage -= 1))
            }, " Anterior ", 8 /* PROPS */, _hoisted_17),
            _createElementVNode("span", _hoisted_18, _toDisplayString($setup.currentPage) + " / " + _toDisplayString($setup.totalPages), 1 /* TEXT */),
            _createElementVNode("button", {
              type: "button",
              class: "rounded border border-[#E5E5E5] px-2 py-1 font-medium disabled:cursor-not-allowed disabled:opacity-40",
              disabled: $setup.currentPage === $setup.totalPages,
              "aria-label": "Próxima página",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.currentPage += 1))
            }, " Próxima ", 8 /* PROPS */, _hoisted_19)
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}